var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 3v5a2 2 0 0 0 2 2h5z",
    fill: "#1ce7b2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.707 9.293l-7-7A1 1 0 0 0 19 2H8a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V10a1 1 0 0 0-.293-.707zM20 5.414L23.586 9H21a1 1 0 0 1-1-1zM24 28H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10v4a3 3 0 0 0 3 3h4v16a1 1 0 0 1-1 1zm-5.981-14.2a1 1 0 0 1 1.961.392l-2 10a1 1 0 0 1-1.961-.393z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2zm-1 4h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.02 13.8a1 1 0 1 1 1.96.392l-2 10a1 1 0 1 1-1.96-.393z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.ad178f6e228a5057c781bd1013fa578f.svg";
export { ForwardRef as ReactComponent };